module.exports = __webpack_public_path__ + "static/nat-1-51c662deb11e0ee41425ce1aa2d08d4a.jpg";